
import { ViolationPageContent } from './ViolationPageContent'
import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'

export const ViolationPage = withDefaultErrorBoundary(ViolationPageContent)
